<template>
  <va-card :title="$t('menu.permissions')">
    <div class="row">
      <div class="flex md2 sm6 xs12">
        <va-button
          medium
          inline
          color="#ff842b"
          icon="fa fa-chevron-left"
          class="ma-0"
          :to="{ name: 'roles', params: {
            current_page: this.$route.params.current_page, 
            searchName: this.$route.params.searchName, 
            perPage: this.$route.params.perPage }
            }"
        >
          {{ $t('menu.back') }}
        </va-button>
      </div>
    </div>
    <va-card stripe="secondary">
      <div class="row">
        <div class="flex xs4 md4" v-for="permission_menus in splitedPermisssionMenus" :key="permission_menus.id">
          <va-tree-root>
            <va-tree-category isOpen color="secondary" v-for="item in permission_menus" :key="item.id" :label="item.name">
              <div slot="checkbox">
                <template v-if="ability.can('update', 'RolePermissions')">
                  <va-checkbox
                    v-model="item.enabled"
                    @click.native="toogleRolePermission(item.id, item.enabled)"
                  />
                </template>
                <template v-else>
                  <va-checkbox readonly v-model="item.enabled"/>
                </template>
              </div>
              <va-tree-category color="grey" v-for="subitem in item.submenus" :key="subitem.id" :label="subitem.name">
                <div slot="checkbox">
                  <template v-if="ability.can('update', 'RolePermissions')">
                    <va-checkbox
                      v-model="subitem.enabled"
                      @click.native="toogleRolePermission(subitem.id, subitem.enabled)"
                    />
                  </template>
                  <template v-else>
                    <va-checkbox readonly v-model="subitem.enabled"/>
                  </template>
                </div>
                <va-tree-node v-for="permission in subitem.permissions" :key="permission.id">{{ permission.name }}
                  <div slot="checkbox">
                    <template v-if="ability.can('update', 'RolePermissions')">
                      <va-checkbox
                        v-model="permission.enabled"
                        @click.native="toogleRolePermission(permission.id, permission.enabled)"
                      />
                    </template>
                    <template v-else>
                      <va-checkbox readonly v-model="permission.enabled"/>
                    </template>
                  </div>
                </va-tree-node>
              </va-tree-category>
            </va-tree-category>
          </va-tree-root>
        </div>
      </div>
    </va-card>

    <!-- <div class="row" v-for="i in Math.ceil(permission_menus.length / 3)" :key="i">
      <div class="flex xs4 md4" v-for="item in permission_menus.slice((i - 1) * 3, i * 3)" :key="item.id">
        <va-collapse>
          <span slot="header" style="width:100%"> 
            {{ item.name }}
            <va-toggle v-model="item.enabled" 
              color="#CB022A"
              small
              style="float:right;margin:0;" 
              @click.native="toogleRolePermission(item.id, item.enabled)"
            />
          </span>
          <div slot="body">
            <va-collapse v-for="subitem in item.submenus" :key="subitem.id">
              <span slot="header" style="width:100%"> 
                {{ subitem.name }}
                <va-toggle v-model="subitem.enabled" 
                  color="#CB022A"
                  small
                  style="float:right;margin:0;" 
                  @click.native="toogleRolePermission(subitem.id, subitem.enabled)"
                />
              </span>
              <div slot="body">
                <div v-for="permission in subitem.permissions" :key="permission.id">
                  {{ permission.name }}
                  <va-toggle v-model="permission.enabled" 
                    color="#CB022A"
                    small
                    style="float:right;margin:0;"
                    @click.native="toogleRolePermission(permission.id, permission.enabled)"
                  />
                  <va-separator/>
                </div>
              </div>
            </va-collapse>
          </div>
        </va-collapse>
      </div>
    </div> -->
  </va-card>
</template>

<script>
import { mapState } from "vuex";
import { Ability } from '@casl/ability'
export const ability = new Ability()

import PermissionAPI from '@/services/PermissionAPI'
import RolePermissionAPI from '@/services/RolePermissionAPI'

export default {
  data () {
    return {
      ability: [],
      permission_menus: [],
      role_id: '',
      permission: {
        id: '',
        enabled: ''
      }
    }
  },

  computed: {
    ...mapState(['rules']),

    splitedPermisssionMenus(){
      return _.chunk(this.permission_menus, 3)
    }
  },
  beforeMount(){
    this.ability = ability.update(this.rules)
  },

  mounted () {
    this.role_id = this.$route.params.role_id
    this.getPermissionMenus()
  },

  methods: {
    toogleRolePermission(permission_id, enabled){
      if (enabled) {
        RolePermissionAPI.create(this.role_id, permission_id).then(response =>{
          this.getPermissionMenus()
        })
      } else {
        RolePermissionAPI.delete(this.role_id, permission_id).then(response =>{
          this.getPermissionMenus()
        })
      }
    },

    getPermissionMenus(){
      PermissionAPI.getPermissionMenus(this.role_id).then(response => {
        this.permission_menus = response.data.permissions
      })
    },
  }
}
</script>

<style>
</style>
